import type { PermissionsColumnKey } from "@/modules/permissions";
import type { ToastApi } from "@/ds";
import type { PermissionSort } from "@/modules/permissions";
import { exportPermissions } from "@/modules/permissions";
import { createExportFeedback, describeReportFilters, useFileExport } from "@/modules/export";
import { PERMISSIONS_EXPORT_FILE_NAME } from "../permissions.constants";

interface UsePermissionsExportacaoParams {
  /** Colunas visíveis da tela, na ordem; a exportação leva só elas. */
  readonly colunas: readonly PermissionsColumnKey[];
  readonly search: string;
  readonly sort: PermissionSort;
  /** Listagem vazia: Exportar Visualização avisa "nada a exportar" sem pedir o arquivo. */
  readonly isEmpty: boolean;
  readonly toast: ToastApi;
}

/**
 * Exportar Visualização (HU 1442): o arquivo é gerado pelo servidor com a busca e a ordenação em vigor, sem paginação
 * (RN003), e o servidor registra a exportação na auditoria.
 */
export function usePermissionsExportacao({
  colunas,
  search,
  sort,
  isEmpty,
  toast,
}: UsePermissionsExportacaoParams) {
  return useFileExport({
    fileName: PERMISSIONS_EXPORT_FILE_NAME,
    loadFile: (format) =>
      exportPermissions({
        pesquisa: search,
        sort,
        filtros: describeReportFilters(search, [], {}),
        colunas,
        format,
      }),
    isEmpty: () => isEmpty,
    ...createExportFeedback(toast),
  });
}
